<template>
	<v-dialog v-model="dialog" max-width="500" persistent>
		<v-card>
			<v-toolbar flat dense cad color="info" dark>
				<v-toolbar-title class="subheading text-xs-center">Confirm Sign Off</v-toolbar-title>
				<v-spacer></v-spacer>
			</v-toolbar>

			<v-card-text class="py-5">
				<p>Are you sure you wish to sign off on this Performance Review?</p>
				<v-alert v-if="!employeeSubmissionComplete" :value="true" color="warning" icon="priority_high" outline>
					The {{ $term('employee') }} has not submitted their part of this Performance Review. Signing off will complete the review and prevent them from submitting it later.
				</v-alert>
			</v-card-text>

			<v-divider></v-divider>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-spacer></v-spacer>
				<v-btn flat @click="onCancelClicked">Cancel</v-btn>
				<v-btn color="primary" flat @click="onSignOffClicked">Confirm</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		props: {
			dialog: {
				type: Boolean,
				required: true
			},
			employeeSubmissionComplete: {
				type: Boolean,
				default: true
			}
		},
		methods: {
			onSignOffClicked() {
				this.$emit('onSignOff');
			},
			onCancelClicked() {
				this.$emit('onCancel');
			}
		}
	};
</script>
